import { createWorkerAction } from '../lib';

export const goToPricingPlanPicker = createWorkerAction(
  'GO_TO_PRICING_PLAN_PICKER',
);
